
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graph/[table]",
      function () {
        return require("private-next-pages/graph/[table].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graph/[table]"])
      });
    }
  